import React, { FC, useEffect, useState } from 'react';

import classNames from 'classnames';
import { config } from 'config/config';
import routePaths from 'config/routes';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import NotificationDot from 'src/components/general/NotificationDot';
import Link from 'src/components/Link';
import { IRootReducers } from 'src/reducers';
import { getCookiesFromClient, getUserData } from 'utils';

const {
  COOKIES: { TOAST_COOKIE },
} = config;

type Props = ReturnType<typeof mapStateToProps>;

const SignInHeaderConsumer: FC<Props> = ({
  accessToken,
  user,
  userPoints,
}): JSX.Element => {
  const { formatMessage } = useIntl();
  const [updateUserPoints, setUpdateUserPoints] = useState(false);
  const userData = getUserData(user);
  const newUserPoints = getCookiesFromClient(TOAST_COOKIE);

  useEffect(() => {
    if (newUserPoints) {
      setUpdateUserPoints(true);

      setTimeout(() => {
        setUpdateUserPoints(false);
      }, 6000);
    }
  }, [newUserPoints]);

  const pointsLabelClassName = classNames(
    'basicHeader__signin__icon--points-text basicHeader__signin__icon--points-text-desktop',
    // { 'addPoints-desktop': updateUserPoints }
  );
  // const nameLabelClassName = classNames({ addPoints: updateUserPoints });

  const iconLabelClassName = classNames(
    'basicHeader__signin__icon basicHeader__signin__icon--user',
    // { 'addPoints-icon': updateUserPoints }
  );

  return (
    <>
      {user && (
        <div className="basicHeader__signin__dropdown layout">
          <div className="link">
            <Link
              href={
                accessToken
                  ? routePaths.PAGES.MY_ACCOUNT.ACCOUNT_INDEX
                  : routePaths.PAGES.LOGIN
              }>
              <div className="basicHeader__signin__wrapper basicHeader__signin__text">
                <div className={iconLabelClassName} />
                <span className="fs-mask">
                  {formatMessage(
                    { id: 'menu.header.hello.name' },
                    {
                      ...userData,
                    },
                  )}
                  <b className={pointsLabelClassName}>
                    {typeof userPoints === 'number' &&
                      formatMessage(
                        { id: 'menu.header.points' },
                        { points: Number(userPoints).toLocaleString() },
                      )}
                  </b>
                  <NotificationDot position="text" />
                </span>
                <a className="icon icon--arrow-dropdown-right" />
              </div>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
    accessToken: state.auth.accessToken,
    userPoints: state.auth.userPoints,
  };
};

export default connect(mapStateToProps)(SignInHeaderConsumer);
